import React, { useState } from "react";
import * as Fa from "react-icons/fa";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { toast } from "react-toastify";
import storage from "../../../Services/Storage";
import { createAPIEndpointCreditMReports, EndpointCreditMReports } from "../../../Services/ReportsAll/CreditManagementReports";
import { downloadExcel } from "../../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat, GetDateFormatTime } from "../../../Services/GlobalFunc/DateFormat";
import { InputNumber } from "primereact/inputnumber";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const SalesAgeingReport = () => {
    const auth = storage.getLocal("user");
    const [fileTypes, setFileTypes] = useState("xlsx");
    const [dayInterval, setDayInterval] = useState(0);
    const [type, setType] = useState("Cust");
    const [rptType, setRptType] = useState("Summary");
    const [loadingExcel, setLoadingExcel] = useState(false);
    const FileType = ["xlsx", "csv"];
    const ReportOptions = [
        { value: "1", text: "Receivables with Ageing" },
        { value: "2", text: "Documents Overdue With Ageing" },
        { value: "3", text: "Collection Forecasting" }
    ];
    // const blockInvalidChar = (e) => {
    //     [".", "+", "-", "e", "E"].includes(e.key) && e.preventDefault();
    // };
   

    const downloadExcelSalesAgeing = async (data, fileName) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet1");
      
        if (!data || data.length === 0) return;
      
        const headers = Object.keys(data[0]);
        worksheet.addRow(headers);
      
        const columnCount = headers.length;
      
        // Find index of "Credit Limit Usage(%)" column
        const creditUsageIndex = headers.findIndex(h => h.trim().toLowerCase() === "credit limit usage(%)".toLowerCase()) + 1;
      
        data.forEach((rowData) => {
            const row = worksheet.addRow(headers.map(header => rowData[header]));
      
            if (creditUsageIndex > 0) {
                const usageValue = row.getCell(creditUsageIndex).value;
      
                if (
                    typeof usageValue === "number" &&
              usageValue > 100
                ) {
                    // Apply red background to the entire row
                    for (let i = 1; i <= columnCount; i++) {
                        row.getCell(i).fill = {
                            type: "pattern",
                            pattern: "solid",
                            fgColor: { argb: "FFFF0000" }, // Red
                        };
                    }
                }
            }
        });
      
        // Header styling
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true };
        headerRow.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFD3D3D3" }, // Light gray
        };
        headerRow.eachCell(cell => {
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });
      
        worksheet.columns.forEach(col => {
            col.width = Math.max(10, col.header?.toString().length || 10);
        });
      
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      
        saveAs(blob, fileName);
    };
    const handleExportExcel = async () => {
        setLoadingExcel(true);
        try {
            const res = await createAPIEndpointCreditMReports().get(`${EndpointCreditMReports.salesAgeingRptDownload}?CompId=${auth.CompId}&type=${type}&reportType=${rptType}&dayInterval=${dayInterval.toString()}`);
            // console.log(res, "handleExportExcel");
            if (res.data.length == 0) {
                toast.warning(
                    "No data found",
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    }
                );
                setLoadingExcel(false);
            }
            else {
                if (fileTypes === "xlsx") {
                    downloadExcelSalesAgeing(res.data, `SalesAgeing${rptType}${GetDateFormat()}.xlsx`);
                }
                else if (fileTypes === "csv") {
                    downloadExcel(res.data, `Sales_Ageing_${rptType}_${GetDateFormatTime()}.csv`);
                }
                else {
                    toast.warning(
                        "Please select file type",
                        {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        }
                    );
                }
                setLoadingExcel(false);
            }
        } catch (ex) {
            toast.error(
                ex.response.data.Message,
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                }
            );
            setLoadingExcel(false);
        }
    };

    return (
        <div className="col-12 pt-0 pb-4">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <h3 className="py-2">Sales Ageing Report</h3>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="text-end mb-2">
                        <div className="display-b me-2">
                            <Dropdown
                                placeholder="Select"
                                options={FileType}
                                value={fileTypes}
                                onChange={(e) => {
                                    setFileTypes(e.value);
                                }}
                            />
                        </div>

                        <button type="button" className="btn btn-primary" onClick={handleExportExcel} disabled={loadingExcel}>
                            {loadingExcel ? "Loading..." : "Download"}{" "}
                            {loadingExcel ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : (
                                <Fa.FaDownload className="ms-2" />
                            )}
                        </button>
                    </div>

                </div>
            </div>

            <section className="sales-box">
                <form>
                    <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-12 mb-3 pt-1">
                            <label className="form-label mb-2">Report</label>
                            <Dropdown value={"1"} options={ReportOptions} optionLabel="text"
                                placeholder="Select a City" className="w-full md:w-14rem" disabled />

                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12 mb-3 pt-1">
                            <label className="form-label mb-2">Day Interval</label>
                            {/* <input className="form-control" value={dayInterval} type="number" onKeyDown={blockInvalidChar} onChange={(e) => {
                                if (e.target.value.toString().startsWith("-")) {
                                    toast.warning("Purchase order quantity should not be negative value", {
                                        position: toast.POSITION.TOP_CENTER,
                                        pauseOnFocusLoss: false,
                                        closeButton: false,
                                        autoClose: 8000,
                                    });
                                    setDayInterval(0);
                                } else {
                                    setDayInterval(parseInt(e.target.value.replace(/^(-?)0+/, "$1"), 10));
                                }
                            }}
                            /> */}
                            <InputNumber className="d-block" inputId="Interval" value={dayInterval} onValueChange={(e) => setDayInterval(e.value)}  min={1} max={60} />
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12 mb-3 pt-1">
                            <label className="form-label d-block">Type</label>
                            <div className="flex align-items-center d-inline me-3">
                                <RadioButton inputId="Type" name="Type" value="Cust" onChange={(e) => setType(e.value)} checked={type === "Cust"} />
                                <label htmlFor="Type" className="ms-2">Customer</label>
                            </div>
                            <div className="flex align-items-center d-inline">
                                <RadioButton inputId="Type" name="Type" value="SE" onChange={(e) => setType(e.value)} checked={type === "SE"} />
                                <label htmlFor="Type" className="ms-2">Sales Executive</label>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12 mb-3 pt-1">
                            <label className="form-label d-block">Report Type</label>
                            <div className="flex align-items-center d-inline me-3">
                                <RadioButton inputId="RptType" name="RptType" value="Summary" onChange={(e) => setRptType(e.value)} checked={rptType === "Summary"} />
                                <label htmlFor="RptType" className="ms-2">Summary</label>
                            </div>
                            <div className="flex align-items-center d-inline">
                                <RadioButton inputId="RptType" name="RptType" value="Detail" onChange={(e) => setRptType(e.value)} checked={rptType === "Detail"} />
                                <label htmlFor="RptType" className="ms-2">Detail</label>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    );

};

export default SalesAgeingReport;